export default defineNuxtRouteMiddleware(async (to) => {
  const { $config } = useNuxtApp();
  if ($config.public.maintenance) {
    if (to.path === '/maintenance') {
      return;
    }
    return navigateTo('/maintenance');
  }
});
